import { render, staticRenderFns } from "./loader-animation-palms.vue?vue&type=template&id=5e2c6fee&scoped=true&"
import script from "./loader-animation-palms.vue?vue&type=script&lang=js&"
export * from "./loader-animation-palms.vue?vue&type=script&lang=js&"
import style0 from "./loader-animation-palms.vue?vue&type=style&index=0&id=5e2c6fee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2c6fee",
  null
  
)

export default component.exports